import { Action } from '@ngrx/store';
import {CheckLicenseModel, CheckLicenseParams} from '../check-license.model';

export enum CheckLicenseActionTypes {
  LoadCheckLicenses = '[CheckLicense] Load CheckLicenses',
  GetCheckLicenses = '[CheckLicense] Get CheckLicenses',
  ClearCheckLicenses = '[CheckLicense] Clear CheckLicenses'
}

export class LoadCheckLicenses implements Action {
  readonly type = CheckLicenseActionTypes.LoadCheckLicenses;
  constructor(public payload: CheckLicenseModel ) {}
}

export class GetCheckLicenses implements Action {
  readonly type = CheckLicenseActionTypes.GetCheckLicenses;
  constructor(public payload: CheckLicenseParams) {}
}

export class ClearCheckLicenses implements Action {
  readonly type = CheckLicenseActionTypes.ClearCheckLicenses;
}


export type CheckLicenseActions = LoadCheckLicenses
  | GetCheckLicenses
  | ClearCheckLicenses;
